var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.questions.length && _vm.groupNames.length)?_c('div',{staticClass:"nps-card"},[_c('div',{staticClass:"nps-card-title"},[_vm._v("Evaluacion 1-5 por "+_vm._s(_vm.groupLabel)+": "+_vm._s(_vm.questionList))]),_vm._v(" "),_c('charts',{attrs:{"options":_vm.chartOptions}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2967da71","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/rounds/nps-dashboard/components/GroupedAttributesSection.vue
// module id = null
// module chunks = 